import React from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { SessionInactiveModalProps } from './models';
import { PopupWrapper, Popup } from '@sunbit-dev/purchase-common/src/components/popup/Popup';
import classNames from 'classnames';
import { PrivacyAllowanceLayer } from '@sunbit-dev/purchase-common/src/components/privacyAllowanceLayer/PrivacyAllowanceLayer';
import disconnectedIcon from '~/assets/broken-link.svg';
import { useTranslation } from '@sunbit-dev/translations';
import useTimer from '@sunbit-dev/purchase-common/src/hooks/useTimer';
import { ActionButton } from '@sunbit-dev/purchase-common/src/components/actionButton/ActionButton';
import { ButtonSize, ButtonType } from '@sunbit-dev/web-ui-lib';
import { PopupTestIds } from '~/enums/TestIds';

export const SessionInactiveModal = styled(({ className, modalDuration, onClose }: SessionInactiveModalProps) => {
  const { t } = useTranslation('components', { keyPrefix: 'session_inactive_modal' });
  const { countDown } = useTimer(modalDuration);

  return (
    <PopupWrapper dataTestId={PopupTestIds.SessionInactivePopup}>
      <PrivacyAllowanceLayer>
        <Popup className={classNames(className)} onClose={onClose}>
          <div className="inactive-content-text">
            <img className="broken-link-icon" src={disconnectedIcon} alt={t('icon_label')} />
            <div className="modal-text">
              <h2 className="title">{t('title')}</h2>
              <h4 className="description">
                {t('description')[0]} <span className="countdown">{countDown}</span> {t('description')[1]}
              </h4>
            </div>
            <ActionButton
              submit={onClose}
              size={ButtonSize.large}
              className="close-modal"
              type={ButtonType.Button}
              buttonText={t('close_button')}
              dataTestId="session-expired-close-button"
            />
          </div>
        </Popup>
      </PrivacyAllowanceLayer>
    </PopupWrapper>
  );
})`
  ${styles.SessionInactiveModal}
`;
